import { SubjectTypesType } from '../../lib/queryFactory'
import { useCallback, useState, useRef, useEffect } from 'react'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'

import usePool from '@duckness/use-pool'
import InsightsDashboardPool, { DashboardDuck } from '@aytm/app/insights/dashboard/duckness/InsightsDashboardPool'
import { SUBJECT_TYPES } from '@aytm/app/insights/dashboard/lib/config'
import { poolDispatch } from '@aytm/app/insights/dashboard/duckness/poolDispatch'
import { makeUpdateTitleDashboardAction } from '@aytm/app/insights/dashboard/duckness/ducks/DashboardDuck/DashboardDuck.actionCreators'

export type UseTitlePropsType = { subjectType?: SubjectTypesType; updateTabTitle?: boolean }

const useTitle = ({ subjectType = 'concept', updateTabTitle = false }: UseTitlePropsType = {}) => {
  const title = usePool(InsightsDashboardPool, DashboardDuck.select.title)
  const lastTitle = useRef<string>(title)

  const [currentTitle, setCurrentTitle] = useState(title)

  const updateTitle = useCallback(
    (newTitle: string = 'Insights') => poolDispatch(makeUpdateTitleDashboardAction(newTitle, lastTitle.current)),
    []
  )

  useEffect(() => {
    if (lastTitle.current !== title) {
      lastTitle.current = title
      setCurrentTitle(title)
    }
  }, [title])

  useEffect(() => {
    if (updateTabTitle) {
      const type =
        subjectType === SUBJECT_TYPES.CONCEPT ? ' Concept' : subjectType === SUBJECT_TYPES.WAVE ? ' Tracker' : ''
      document.title = `${decode(title)} | AYTM${type} portal`
    }
  }, [subjectType, title, updateTabTitle])

  return {
    title,
    updateTitle,
    currentTitle,
    setCurrentTitle
  }
}

export default useTitle
